export const type = 'form.radio';
